import {
  components,
} from '@/generated/qmulus/openapi.ts';

export enum ESettingsSectionType {
  DEFAULT = 'DEFAULT',
  REMOTE_CONTROL_PT9800 = 'REMOTE_CONTROL_PT9800',
  APP_OVERVIEW = 'APP_OVERVIEW',
}

export const settingsSectionType: Record<components['schemas']['SettingsSectionType'], keyof typeof ESettingsSectionType> = {
  DEFAULT: 'DEFAULT',
  REMOTE_CONTROL_PT9800: 'REMOTE_CONTROL_PT9800',
  APP_OVERVIEW: 'APP_OVERVIEW',
};
